import { render, staticRenderFns } from "./BasicCheckbox.vue?vue&type=template&id=0250edf0&scoped=true&"
import script from "./BasicCheckbox.vue?vue&type=script&lang=js&"
export * from "./BasicCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BasicCheckbox.vue?vue&type=style&index=0&id=0250edf0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0250edf0",
  null
  
)

export default component.exports